export const visitorTypeHelpText = (visitorTypesData: any): string => {
  if (!visitorTypesData) return ""

  if (visitorTypesData.length > 0) {
    return "Available visitor type tags: " + visitorTypesData.map(({tag}: { tag: string }) => tag).join(", ")
  } else {
    return "No available visitor type tags"
  }
}
